import StatementReleaseDialog from './StatementReleaseDialog';

export default StatementReleaseDialog;
